import $ from 'jquery';
import xor from 'lodash/xor';
import isEmpty from 'lodash/isEmpty';
import { openModal, closeModal } from '../ui/modal';

export default function() {
	$('.marketing-permissions #kconsent-show-v1').on('click', () => {
		history.replaceState(null, '', '?kconsent=active');
	})

	const initialSelection = $('.v4-form input[type=checkbox]:checked').map(function() {
		return this.name;
	}).get();

	$('.marketing-permissions .accordion-items .btn-link').on('click', function(e) {
		const currentSelection = $('.marketing-permissions-form input[type=checkbox]:checked').map(function() {
			return this.name;
		}).get();
		const differingSelection = xor(initialSelection, currentSelection);

		if (!isEmpty(differingSelection)) {
			e.preventDefault();
			const unsavedForm = $('.marketing-permissions-form input[type=checkbox]').filter(function() {
				return differingSelection.includes(this.name);
			})[0].form

			const modalContent = `
			<div class="section">
				<p class="my-4">Sinulla on tallentamattomia valintoja aiemmassa välilehdessä. Haluatko tallentaa ne ennen kuin siirryt eteenpäin.</p>
				<div class="buttons">
					<button type="submit" class="button btn-danger" form="${unsavedForm.id}">Tallenna</button>
					<button class="button close-form-alert-modal">Poistu tallentamatta</button>
				</div>
			</div>`;

			openModal(null, {
				compact: true,
				centerVertical: true,
				disableBodyScroll: true,
				content: modalContent,
				onClose: () => { initialSelection.push(...differingSelection); }
			});

			$('.close-form-alert-modal').on('click', function() { closeModal() })
		}
	})
}
